import { OcResponseModel } from "./oc";
import { defaultTuzAccession } from "./client";
import { defaultOneShareAcquisition } from "./client";
import { OtherClaimlessPolicyDiscountValues } from "./discount";
import { StoreCalculationService } from "../services/services/storeCalculationService";
import { ClientStore } from "../stores/clientStore";

interface InsuranceSumAndRate {
    insuranceSum: number;
    rate: number;
}

export interface Corrections {
    claimlessPolicyClientDiscount: OtherClaimlessPolicyDiscountValues | null;
}

export interface EntryFees {
    tuzAccession: number | null;
    oneShareAcquisition: number | null;
}

export interface CalculationResponseModel {
    calculationId: number | null;
    totalAmount: number;
    totalAmountToPay: number;
    coverages: {
        houseOrFlatWithFixedElements: InsuranceSumAndRate | null;
        additionalRisks: {
            devastation: InsuranceSumAndRate | null,
            theft: InsuranceSumAndRate | null,
            searchingAndRemovingCauseOfDamage: InsuranceSumAndRate | null,
            windowpanes: InsuranceSumAndRate | null,
            surges: InsuranceSumAndRate | null,
            buildingToolsAndMaterials: InsuranceSumAndRate | null
        };
        assistance: InsuranceSumAndRate | null;
        onlyFixedElements: InsuranceSumAndRate | null;
        movables: InsuranceSumAndRate | null;
        burglaryAndTheftMovables: InsuranceSumAndRate | null;
        fixedElementsWithBurglaryAndTheft: InsuranceSumAndRate | null;
        flood: InsuranceSumAndRate | null;
        catAndDog: InsuranceSumAndRate | null;
        ocInPrivateLife: OcResponseModel | null;
        gravestone: InsuranceSumAndRate | null;
        greenEnergySources: InsuranceSumAndRate | null;
        legalProtectionType: InsuranceSumAndRate | null;
        nnw: InsuranceSumAndRate | null;
        nonResidentialBuildings: InsuranceSumAndRate | null;
        propertyFixedElements: InsuranceSumAndRate | null;
        safeSenior: InsuranceSumAndRate | null;
        corrections: Corrections | null;
        secondOpinion: {
            standard: number | null,
            familyExtension: number | null
        }
    };
    installments: InstallmentsResponse[];
    entryFees: EntryFees | null;
    exceededProxies?: string[] | null;
}

export interface InstallmentsResponse {
    id: number;
    amount: number;
    dueDate: string;
}

export const DefaultCalculationResponse: CalculationResponseModel = {
    calculationId: 0,
    totalAmount: 0,
    totalAmountToPay: 0,
    coverages: {
        houseOrFlatWithFixedElements: null,
        additionalRisks: {
            devastation: null,
            theft: null,
            searchingAndRemovingCauseOfDamage: null,
            windowpanes: null,
            surges: null,
            buildingToolsAndMaterials: null
        },
        assistance: null,
        onlyFixedElements: null,
        movables: null,
        burglaryAndTheftMovables: null,
        fixedElementsWithBurglaryAndTheft: null,
        flood: null,
        catAndDog: null,
        ocInPrivateLife: null,
        gravestone: null,
        greenEnergySources: null,
        legalProtectionType: null,
        nnw: null,
        nonResidentialBuildings: null,
        propertyFixedElements: null,
        safeSenior: null,
        corrections: null,
        secondOpinion: {
            standard: null,
            familyExtension: null
        }
    },
    installments: [{ id: 0, amount: 0, dueDate: "" }],
    entryFees: {
        tuzAccession: defaultTuzAccession,
        oneShareAcquisition: defaultOneShareAcquisition
    }
};

export function onSaveCalculationButtonClick(storeCalculationService: StoreCalculationService, clientStore: ClientStore) {
    storeCalculationService.reset();
    const calculationName = new Date().toLocaleDateString() + " " + clientStore.insurerName;
    storeCalculationService.setSaveName(calculationName);
}
